import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import classNames from "classnames";
import { useCustomLocale } from "./hooks/useCustomLocale/useCustomLocale";
import { CustomMonthCaption } from "./utils/CustomMonthCaption";
import { DatePickerFooter } from "./DatePickerFooter";
import "react-day-picker/style.css";
import styles from "./DatePicker.module.scss";
export const DatePicker = ({ onSaveSelection, currentlyBookedDate, numberOfMonths = 2, hideNavigation = true, disabledRange, footer, disableDisabled = false, ...rest }) => {
    const customLocale = useCustomLocale();
    const [selected, setSelected] = useState();
    const handleSaveSelection = () => {
        if (onSaveSelection && selected) {
            onSaveSelection(selected);
        }
    };
    const disabledBefore = disabledRange?.before || new Date(new Date().setDate(new Date().getDate() + 1));
    const disabledAfter = disabledRange?.after || new Date(new Date().setMonth(new Date().getMonth() + 1));
    return (_jsx(DayPicker, { mode: "single", className: classNames(styles.datePicker, "light-theme"), locale: customLocale, numberOfMonths: numberOfMonths, hideNavigation: hideNavigation, defaultMonth: new Date(), selected: selected, onSelect: setSelected, useAdditionalDayOfYearTokens: true, components: {
            MonthCaption: (props) => _jsx(CustomMonthCaption, { ...props }),
        }, footer: footer || _jsx(DatePickerFooter, { onSaveSelection: handleSaveSelection, selected: selected }), ...(currentlyBookedDate
            ? {
                modifiers: { booked: currentlyBookedDate },
                modifiersClassNames: { booked: "currentlyBooked" },
            }
            : {}), disabled: !disableDisabled ? [{ before: disabledBefore }, { after: disabledAfter }] : [], ...rest }));
};
//# sourceMappingURL=DatePicker.js.map